import { render, staticRenderFns } from "./SidebarSistarum.vue?vue&type=template&id=d928e532&"
import script from "./SidebarSistarum.vue?vue&type=script&lang=js&"
export * from "./SidebarSistarum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports